import { Reducer } from 'redux';
import { makeid } from '../../../utils/formatStrings';
import {
  Types,
  INotificationsState,
  ENotificationTypes,
  INotification,
  INewContractNotification
} from './types';

const INITIAL_STATE: INotificationsState = {};

type CustomAction = {
  type: Types;
  payload: {
    newContractNotifications: INewContractNotification[];
    notificationsToRemove: INotification[];
  };
};

const reducer: Reducer<INotificationsState, CustomAction> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case Types.ADD_NOTIFICATIONS:
      return {
        ...state,
        newContractNotifications: [
          ...(addNotifications(
            state.newContractNotifications || [],
            action.payload.newContractNotifications
          ) as INewContractNotification[])
        ]
      };

    case Types.REMOVE_NOTIFICATIONS:
      return removeNotifications(state, action.payload.notificationsToRemove);

    default:
      return state;
  }
};

const addNotifications = (
  notifications: INotification[],
  newNotifications: INotification[]
): INotification[] => {
  newNotifications.forEach((notification) => {
    if (
      !notifications.find(
        (n) => n.title === notification.title && n.type === notification.type
      )
    ) {
      notifications.push({
        ...notification,
        id: makeid(8)
      });
    }
  });

  return notifications;
};

const removeNotifications = (
  notificationsState: INotificationsState,
  notificationsToRemove: INotification[]
): INotificationsState => {
  notificationsToRemove.forEach((notification) => {
    if (notification.type === ENotificationTypes.NEW_CONTRACT) {
      notificationsState.newContractNotifications =
        notificationsState.newContractNotifications?.filter(
          (notif) => notif.id !== notification.id
        );
    }
  });

  return notificationsState;
};

export default reducer;
